export default {"src":"/org/_next/static/media/menu.e85064a5.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};